<template>
    <page>
		<module enable-flex>
			<c-table ref="table" :paging="false">
				<c-table-column
					type="expand"
					label="区域"
					name="region_name"
					:expand-limit="2"
					width="160"
					@expand="loadChildren"
				>
				</c-table-column>
				
				<c-table-column label="代理开通价格" width="100" name="sale_price">
					<template v-slot="{data}">
						<span v-if="data.sale_price">{{(parseFloat(data.sale_price)).toFixed(2)}}元</span>
						<span v-else>-</span>
					</template>
				</c-table-column>
				
				<c-table-column label="代理限售数量" width="100" name="max_agency_count">
					<template v-slot="{data}">
						{{data.max_agency_count}}个
					</template>
				</c-table-column>
				
				<c-table-column
						label="代理"
						width="300"
				>
					<template v-slot="{data}">
						<div class="flex-wrap" v-if="data.agent_names">
							<div v-for="(item, j) in (data.agent_names.split(','))" :key="j" class="agent">
							  {{item}}
							</div>
						</div>
					</template>
				</c-table-column>
				
				<c-table-column
						label="爆款代理"
						width="400"
				>
					<template v-slot="{data}">
						<div  class="flex-wrap"  v-if="data.region_type == 2 && data.product_agent_names">
							<div v-for="(item, j) in (data.product_agent_names.split(','))" :key="j"  class="agent">
							  {{item}}
							</div>
						</div>
						<span v-else>-</span>
					</template>
				</c-table-column>
					
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="row">
						<c-table-button power="b_region_set" @click="editHandle(row)">配置</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
	    <c-dialog ref="dialog" :title="`『${region_name}』代理配置`" width="1000" @resolve="configSaveHandle">
		    <c-form ref="form">
				
				<c-form-item type="number" :label="`${agent_config_title}数量`" name="max_agency_count" required word="在当前地区最大可开放代理数量" input-unit="个"></c-form-item>
				<c-form-item type="number" :label="`${agent_config_title}售价`" name="sale_price" required word="在当前地区购买成为代理的价格" input-unit="元"></c-form-item>
				
				<c-form-item :label="`${agent_config_title}管理`">
					<m-operate>
						<c-button hollow @click="$refs.agentSelector.open()">添加{{agent_config_title}}</c-button>
					</m-operate>
				
					<c-table ref="agentList" v-model="agentList" height="220" :paging="false" border>
						<c-table-column
							:label="`${agent_config_title}手机号`"
							name="user_manage_mobilephone"
							width="120"
						></c-table-column>
					
						<c-table-column
							:label="`${agent_config_title}头像/昵称`"
							width="300"
						>
							<template v-slot="{data}">
								<div class="flex-center-cross">
								  <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
								  <span>{{data.nick_name||'-'}}</span>
								</div>
							</template>
						</c-table-column>
						
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="60"
						>
							<template v-slot="row">
								<c-table-button @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
				  </c-table>
				</c-form-item>
				
				<c-form-item label="爆款代理" v-show="region_type == 2">
					<m-operate>
						<c-button color="gray" hollow @click="$refs.productTypeAgentSelector.open()">添加爆款代理</c-button>
					</m-operate>
				
					<c-table ref="productTypeAgentList" v-model="productTypeAgentList" height="320" :paging="false" border>
						<c-table-column
							:label="`爆款代理手机号`"
							name="user_manage_mobilephone"
							width="120"
						></c-table-column>
					
						<c-table-column
							label="爆款代理头像/昵称"
							width="200"
						>
							<template v-slot="{data}">
								<div class="flex-center-cross">
								  <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
								  <span>{{data.nick_name||'-'}}</span>
								</div>
							</template>
						</c-table-column>
						
						<c-table-column
							label="爆款类目"
							width="400"
						>
							<template v-slot="{data}">
								<div  class="flex-wrap" v-if="data.product_type_list && data.product_type_list.length > 0">
									<div v-for="(item, j) in (data.product_type_list)" :key="j"  class="agent">
									{{item.type_name}}
									</div>
								</div>
								<a v-else style="color:red">未选爆款类目</a>
							</template>
						</c-table-column>
					
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="140"
						>
							<template v-slot="row">
								<c-table-button @click="selectProductType(row)">设置类目</c-table-button>
								<c-table-button @click="row.remove()">删除</c-table-button>
							</template>
						</c-table-column>
				  </c-table>
				</c-form-item>
		    </c-form>
	    </c-dialog>
		
		<!--市代省代选择 -->
	    <member-selector ref="agentSelector" multiple @resolve="selectHandle($event, 'agentList', 'platform_user_id')"></member-selector>
		
		<!--爆款代理选择 -->
		<member-selector ref="productTypeAgentSelector" multiple @resolve="selectHandle($event, 'productTypeAgentList', 'platform_user_id')"></member-selector>

		<!--爆款类目选择-->
		<edit-member-product-classify ref="editMemberProductClassify" @resolve="selectProductTypeHandle"></edit-member-product-classify>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	import memberSelector from '@/components/service/member_selector.vue'
	import editMemberProductClassify from "@/pages/member/member_product_classify.vue";
	
	export default {
		name: 'm_region',
		
		components: {
			memberSelector, editMemberProductClassify
		},
		
		data() {
			return {
				region_id:0,
				region_name: '',
				agent_config_title: '',
				region_type: 1,
				agentList: [],
				productTypeAgentList: []
			}
		},
		
		computed: {
			...mapState(['systemConfig'])
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/platform_user/region/list',
				data: {
					parent_id: 0
				}
			});
		},
		
		methods: {
			loadChildren(row, resolve) {
				this.request({
					url: '/platform_user/region/list',
					data: {
						parent_id: row.data.id
					},
					success: data => {
						resolve(data);
					}
				});
			},

			//区域配置（弹框）
			editHandle(row) {
				this.agentList = [];
				this.productTypeAgentList = [];
				this.region_id = row.data.id;
				this.region_name = row.data.region_name;
				this.region_type = row.data.region_type;
				this._resolve = data => {
					row.update(data);
				};
				this.$refs.form.clear();
				
				if(this.region_type == 1){
					this.agent_config_title = '省代';
				}else if(this.region_type == 2){
					this.agent_config_title = '市代';
				}
				
				//加载详情列表
				this.request({
					url: '/platform_user/region/detail',
					data: {
						region_id: this.region_id
					},
					success: data => {
						//区域详情
						this.$refs.form.set({
							max_agency_count: data.detailInfo.max_agency_count,
							sale_price: data.detailInfo.sale_price
						});
						//代理列表
						this.agentList = data.agencyList;
						//爆款代理列表
						this.productTypeAgentList = data.productTypeAgencyList;
					}
				});
				
				this.$refs.dialog.open();
			},

			//选择代理回调
			selectHandle(list, ref, key) {
			    list = list.filter(item => {
					item.product_type_list = [];
			        return !this[ref].find(row => {
			            return row[key] == item[key];
			        });
			    });
			    this[ref] = this[ref].concat(list);
			},
			
			//按会员选择爆款类目（弹框）
			selectProductType(row){
				this.productRowData = row.data;
				this.$refs.editMemberProductClassify.open(this.region_id, row.data.platform_user_id, row.data.product_type_list);
			},
			
			//会员选择爆款类目（回调）
			selectProductTypeHandle(select_arr){
				//自己类目ID集合
				this.productRowData.product_type_list = select_arr;
			},

			//配置保存提交
			configSaveHandle(stop) {
				stop();
				var formData = this.$refs.form.serialize();
				if (!formData.max_agency_count) {
					this.$message({
						text: '请输入代理数量'
					});
					return;
				}
				if (!formData.sale_price) {
					this.$message({
						text: '请输入代理身份售价'
					});
					return;
				}
				formData.region_id = this.region_id;
				formData.region_type = this.region_type;
				formData.agency_list = this.agentList;
				formData.product_type_agency_list = this.productTypeAgentList;
				this.request({
					url: '/platform_user/region/editConfig',
					data: formData,
					loading: true,
					success: data => {
						this.$message({
						    icon: 'success',  // 图标（success：成功，fail：失败）
						    text:'操作成功'
						});
						
						this.request({
							url: '/platform_user/region/info',
							data: {region_id: this.region_id},
							success: data => {
								this._resolve(data);
								this.$refs.dialog.close();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.agent {
		border: 0px solid #666;
		color: #333;
		padding:3px 6px;
		margin-right:5px;
		margin-bottom: 3px;
		background: #eee;
	}
</style>